@if (user$ | async) {
  <router-outlet />
}
